import React from 'react';
import { PropTypes } from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Table, TableContainer, TableBody } from '@mui/material';
import { WeightedTableRow } from '../../Table/WeightedTableRow';
import OverviewCard from './OverviewCard';

const AboutCard = ({ customer }) => {
  const { t } = useTranslation();
  return (
    <OverviewCard header={t('components.cards.about.about')}>
      {customer && (
        <TableContainer>
          <Table borderless size="sm">
            <TableBody>
              <WeightedTableRow header={t('components.cards.about.registrationNumber')} value={customer.regNumber} />
              {customer.legalForm && (
                <WeightedTableRow
                  header={t('enums.legalForm.name')}
                  value={t(`enums.legalForm.values.${customer.legalForm}`, customer.legalForm)}
                />
              )}
              <WeightedTableRow
                header={t('components.cards.about.country')}
                value={t(`enums.countryCode.values.${customer.countryCode}`, customer.countryCode)}
              />
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </OverviewCard>
  );
};

AboutCard.propTypes = {
  customer: PropTypes.shape({
    regNumber: PropTypes.string.isRequired,
    countryCode: PropTypes.string.isRequired,
    legalForm: PropTypes.string,
  }),
};

export default AboutCard;
